import { formatMoney } from 'accounting-js';
import i18n from '@/i18n';
import moment from 'moment';
import humps from 'humps';

export default function initializeFilters(Vue) {
  Vue.filter('currency', money => formatMoney(money / 100, { symbol: '₮', format: '%v%s' }, 2));
  Vue.filter('currencyWithoutDecimal', money =>
    formatMoney(money / 100, { symbol: '₮', format: '%v%s', precision: 0 })
  );
  Vue.filter('duration', service => {
    let duration = service.durationHours ? `${service.durationHours}h ` : '';
    duration += `${service.durationMinutes}min`;
    return duration;
  });

  Vue.filter('momentDate', (date, format) => moment(date).format(format));

  Vue.filter('fullName', user => {
    return user
      ? `${
          user.lastName && user.lastName.length > 0
            ? `${user.lastName.charAt(0).toUpperCase()}.`
            : ''
        }${
          user.firstName && user.firstName.length > 0
            ? user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)
            : '-'
        }`
      : '';
  });

  Vue.filter('fullAddress', user => {
    let text = '';
    if (user.city) {
      text += `${user.city.name},`;
    }
    if (user.district) {
      text += ` ${user.district.name},`;
    }
    if (user.horoo) {
      text += ` ${user.horoo.name},`;
    }
    if (user.buildingStreet) {
      text += ` ${user.buildingStreet}`;
    }
    if (user.doorNumber) {
      text += ` ${user.doorNumber}`;
    }
    return text;
  });

  Vue.filter('square', square => {
    return `${square}мкв`;
  });

  Vue.filter('minuteToDuration', minutes => {
    return Vue.moment
      .utc()
      .startOf('day')
      .add({ minutes })
      .format('H[h] mm[m]');
  });

  Vue.filter('loanStatusToVerb', status => {
    let text = '';
    if (status === 'PENDING') {
      text = i18n.t('status.loanRequested');
    }
    if (status === 'ACTIVE') {
      text = i18n.t('status.loanIssued');
    }
    if (status === 'PAID') {
      text = i18n.t('status.loanPaid');
    }
    if (status === 'EXTENDED') {
      text = i18n.t('status.loanExtended');
    }
    if (status === 'WRITE_OFF') {
      text = i18n.t('status.loanWriteOff');
    }
    return text;
  });

  Vue.filter('customerStatusToVerb', status => {
    let text = '';
    if (status === 'APPROVED') {
      text = i18n.t('status.customerApproved');
    }
    if (status === 'REQUESTED') {
      text = i18n.t('status.customerRequested');
    }
    if (status === 'CHECKED') {
      text = i18n.t('status.customerChecked');
    }
    if (status === 'CONFIRMED') {
      text = i18n.t('status.customerConfirmed');
    }
    return text;
  });

  Vue.filter('stringCamelize', string => {
    return string ? humps.camelize(string).toLowerCase() : '';
  });
}
